/* -------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2021. All rights reserved
------------------------------------------------------------------------------------------------- */
export const SettingTooltipMixin = (base) =>
  class SetTooltipMixin extends base {
    setTooltip(newValue, tooltip) {
      if (tooltip.id === 'verticalTooltip') {
        tooltip.style.left = `calc(${newValue}% + (${(-12 - newValue * 0.15) / 16}rem))`;
      } else {
        tooltip.style.left = `calc(${newValue}% + (${(8 - newValue * 0.15) / 16}rem))`;
      }
    }
    setTooltipRange(newValue, tooltip) {
      tooltip.style.left = `calc(${newValue}%)`;
    }
  };
